import React from 'react';
import { getImageUrl } from '@wix/communities-blog-client-common';
import { Image } from '@app/external/common/components/image/image';
import { type NormalizedPost } from '@app/external/common/types';
import classes from './post-page-post-header-image.scss';

type Props = {
  post: NormalizedPost;
};

const PostPagePostHeaderImage: React.FC<Props> = (props) => {
  const heroImage = props.post.heroImage;

  const uri2 = getImageUrl({
    image: props.post.heroImage,
    maxHeight: 980,
    maxWidth: props.post.heroImage?.width,
    type: 'fit',
    encoding: 'AVIF',
  });

  if (!uri2) {
    return null;
  }

  return <Image image={heroImage} className={classes.img} displayMode="fit" />;
};

export default PostPagePostHeaderImage;
